module.exports = __webpack_public_path__ + "img/BAC.6732714c.png";